import { render, staticRenderFns } from "./SearchTasksQueueIdNavItem.vue?vue&type=template&id=ffb5d38e&scoped=true&"
import script from "./SearchTasksQueueIdNavItem.vue?vue&type=script&lang=js&"
export * from "./SearchTasksQueueIdNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchTasksQueueIdNavItem.vue?vue&type=style&index=0&id=ffb5d38e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb5d38e",
  null
  
)

export default component.exports